import axios from 'axios'
import { HOME_PAGE_URL, HOME_RECOMMEND_URL, CART_RECOMMEND_URL } from '@api/index'

const { BRANDID } = Config
/** 点餐相关API */
export default class HomeAPI {
  // /**
  //  * 获取首页进入信息
  //  * @param {number} [brandId=BRANDID] - 品牌id
  //  * @desc 扫品牌码：只有brandId则返回品牌所有门店
  //  * @param {number} [storeId] - 门店id
  //  * @desc 扫门店码：有brandId和storeId返回当前门店信息
  //  * @param {string} [memberId] - 用户登陆以后有
  //  * @desc 有memberId则返回门店消费统计
  //  * @param {number} lbsLng - 经度
  //  * @param {number} lbsLat - 纬度
  //  * @desc lbsLng和lbsLat不传则无距离信息
  //  * @returns {Promise<TError & IHomePageRes >}
  //  */
  // static async getHomePage (params: { brandId?: number; storeId?: number; memberId?: string; lbsLng?: number; lbsLat?: number } = {}): Promise<TError & IHomePageRes> {
  //   params = {
  //     ...params,
  //     brandId: BRANDID
  //   }
  //   !params.storeId && delete params.storeId
  //   const res = await axios.post(HOME_PAGE_URL, params).catch((error) => error)
  //   // console.log('res: ', res)
  //   return res.error ? res : res.result
  // }
  /**
   * 获取首页推荐餐品信息
   * @param {number} [brandId=BRANDID] - 品牌id
   * @param {number} storeId - 门店id
   * @param {number} [memberId] - 会员id
   */
  static async getHomeRecommend (params: { brandId?: number; storeId: number; memberId: number }) {
    params = {
      ...params,
      // orderTime: '20:15' // 测试数据，正式去掉
    } as any
    const res = await axios.post(HOME_RECOMMEND_URL, params).catch((error) => error)
    return res.error ? res : res.result
  }

  /**
   * 获取购物车推荐餐品信息
   * @param {number} [brandId=BRANDID] - 品牌id
   * @param {number} storeId - 门店id
   * @param {number} [memberId] - 会员id
   * @param {string[]} productNoList - 已选餐品的productNo
   */
  static async getCartRecommend (params: { brandId?: number; storeId: number; memberId?: number; productNoList: string[] }) {
    params = {
      ...params,
      brandId: BRANDID
    } as any
    const res = await axios.post(CART_RECOMMEND_URL, params).catch((error) => error)
    return res.error ? res : res.result
  }
}
